import React, { useEffect, useState } from 'react'
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, TextField, withStyles } from '@material-ui/core';
import styles from './styles'
import { withTranslation } from 'react-i18next';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { Cancel as CancelIcon, Save as SaveIcon } from '@material-ui/icons';
import { onCloseWithBackdropCurry } from 'services/util/helperFuncs';

function EditTemplateDialog(props) {

  const { classes, t, handleCancel, handleClose, templateToEdit, dialogState } = props;
  const [template, setTemplate] = useState(templateToEdit);

  useEffect(() => {
    setTemplate(templateToEdit);
  }, [templateToEdit]);

  const dialogOk = () => {
    handleClose(template);
  };

  const handleNotOk = () => {
    handleCancel();
  };

  return (
    <Dialog
      className={classes.dialog}
      disableEscapeKeyDown
      fullWidth
      maxWidth={'sm'}
      onClose={onCloseWithBackdropCurry(handleCancel)}
      open={dialogState.open}
    >
      <DialogTitle>{t('editTourTemplate')}
      </DialogTitle>
      <DialogContent>
        {template &&
          <form>
            <div className={classes.rowWrapper}>
              <TextField
                className={classes.formControl}
                label={t('tourTemplateName')}
                onChange={(e) => setTemplate({ ...template, templateName: e.target.value })}
                value={template.templateName}
              />
              <FormControlLabel
                className={classes.disabledCheckbox}
                control={
                  <Checkbox
                    checked={template.disabled}
                    color="primary"
                    onChange={(event) => setTemplate({ ...template, disabled: event.target.checked })}
                    value={template.disabled}
                  />
                }
                label={t('tourTemplateDisabled')}
              />
            </div>
          </form>
        }
      </DialogContent>
      <DialogActions>
        <Button
          color="default"
          onClick={handleNotOk}
        >
          <CancelIcon />&nbsp;{t('dialogCancel')}
        </Button>
        <Button
          color="primary"
          onClick={dialogOk}
        >
          <SaveIcon />&nbsp;{t('save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

EditTemplateDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  dialogState: PropTypes.object.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  templateToEdit: PropTypes.object.isRequired,
};


export default compose(withStyles(styles), withTranslation())(EditTemplateDialog);
